/**
 * © [2023]  Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { useSelector } from 'react-redux';

import { useHistory, withRouter } from 'react-router-dom';
import { QUARTER_END_DATE_MAPPING } from '../utils/tableHead';
import CustomSeparator from '../../../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';

const ResearchExistingCMS64Adjustments = ({ isInvovice = true }) => {
  const createCms64Data = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer?.createCms64Data
  );
  const previousQtrs = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer?.previousQtr
  );
  // previousQtr
  const paymentsData = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer?.paymentsData
  );
  const responseCMSRpt = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer?.responseCMSRpt
  );
  const [finalTotal, setFinalTotal] = useState();
  const [reportData, setReportData] = useState([]);
  const [rebateQtr, setRebateQtr] = useState([]);
  const [gridHeader, setGridHeader] = useState([]);
  const [displayGrid, setDisplayGrid] = useState(false);
  const [calQuarters, setCalQuarters] = useState([]);
  const [qtrDates, setQtrDates] = useState([]);
  const [drugRebateQtrs, setDrugRebateQtrs] = useState([]);
  const history = useHistory();
  const convertQuarterToendDate = (qtr) => {
    const splitData = qtr.split('Q');
    const quater = `Q${splitData[0]}`;
    const year =
      splitData[0] == '4' ? parseInt(splitData[1]) + 1 : splitData[1];
    return `${QUARTER_END_DATE_MAPPING[quater]}${year}`;
  };

  const negativeValueConversion = (val) => {
    const num = parseFloat(val);
    if (isNaN(num)) {
      return '';
    }
    const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    const formattedNum = num.toLocaleString(undefined, options);
    return num < 0
      ? `($ ${Math.abs(num).toLocaleString(undefined, options)})`
      : `$ ${formattedNum}`;
  };

  useEffect(() => {
    let val = 0;
    for (let i = 0; i < 4; i++) {
      val = parseInt(paymentsData.totalInvAdjs[i]) + val;
    }
    setFinalTotal(val);
  }, [paymentsData.totalInvAdjs]);
  useEffect(() => {
    if (previousQtrs !== null && previousQtrs !== undefined) {
      const calQtrsVal = [];
      const drgRebQtr = [];
      const qtrEndDate = [];
      for (let i = 1; i < 5; i++) {
        calQtrsVal.push(previousQtrs[i]);
      }
      for (let i = 6; i < 10; i++) {
        qtrEndDate.push(previousQtrs[i]);
      }
      for (let i = 11; i < 15; i++) {
        drgRebQtr.push(previousQtrs[i]);
      }
      setCalQuarters(calQtrsVal);
      setQtrDates(qtrEndDate);
      setDrugRebateQtrs(drgRebQtr);
    }
  }, [previousQtrs]);
  const calculateRebateQtr = (calenderQtr) => {
    let calQtr = calenderQtr;
    const qtrDatesData = [convertQuarterToendDate(calenderQtr)];
    const splitData = calQtr.split('Q');
    let strtQtrNum = parseInt(splitData[0]);
    let strtQtrYear = parseInt(splitData[1]);
    if (strtQtrNum == 4) {
      strtQtrYear += 1;
      strtQtrNum = 1;
    } else {
      strtQtrNum += 1;
    }
    calQtr = `${strtQtrNum}Q${strtQtrYear}`;
    setRebateQtr(calQtr);
  };
  const calculateCalenderQuarters = (startqtr) => {
    let calQtr = startqtr;
    const qtrDatesData = [convertQuarterToendDate(startqtr)];
    const splitData = calQtr.split('Q');
    let strtQtrNum = parseInt(splitData[0]);
    let strtQtrYear = parseInt(splitData[1]);
    const calendarQtrs = [startqtr];
    for (let i = 0; i < 3; i++) {
      if (strtQtrNum == 1) {
        strtQtrNum = 4;
        strtQtrYear -= 1;
      } else {
        strtQtrNum -= 1;
      }
      calQtr = `${strtQtrNum}Q${strtQtrYear}`;
      const qtrDate = convertQuarterToendDate(calQtr);
      qtrDatesData.push(qtrDate);
      calendarQtrs.push(calQtr);
    }
    setQtrDates(qtrDatesData);
    return calendarQtrs;
  };

  return (
    <div className='tabs-container'>
      <div className='tBillPanel custom-check'>
        <CustomSeparator
          parent1='System'
          parent2='Technical Window'
          parent3='Online Fixes'
          parent4='Research CMS 64 Inv Adjustments'
        />
        <div className='panel tBillPanel-space pb-0'>
          <div className='panel mb-3'>
            <div className='row'>
              <div style={{ width: '100%' }}>
                <fieldset className='custom-fieldset'>
                  <legend
                    className='same-font-family'
                    style={{ color: '#274463' }}
                  >
                    MEDICAID DRUG REBATE SCHEDULE
                  </legend>
                  <div className='row'>
                    <div className='col-sm-4 mt-2'>
                      <div className='form-wrapper p-0 mt-2'>
                        <div className='mui-custom-form input-md field-xl'>
                          <div>
                            <TextField
                              label='Rebate Program'
                              fullWidth
                              placeholder=''
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name='rbtProg'
                              value={
                                createCms64Data?.selectBy == 'single'
                                  ? createCms64Data?.rebateProgramCd
                                  : createCms64Data?.rebateProgramCdByCMS
                              }
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-sm-4 mt-2'>
                      <div className='form-wrapper p-0 mt-2'>
                        <div className='mui-custom-form input-md field-xl'>
                          <div>
                            <TextField
                              label='Report Quarter'
                              fullWidth
                              placeholder=''
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name='quarter'
                              value={createCms64Data.quarter}
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-sm-4 mt-2'>
                      <div className='form-wrapper p-0 mt-2'>
                        <div className='mui-custom-form input-md field-xl'>
                          <div>
                            <TextField
                              label='State'
                              fullWidth
                              placeholder=''
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name='quarter'
                              value='Maryland'
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-sm-4'>
                      <div className='form-wrapper p-0 mt-2'>
                        <div className='mui-custom-form input-md field-xl'>
                          <div>
                            <TextField
                              label='Final Total'
                              className={
                                finalTotal < 0
                                  ? 'txt-right negative-balance'
                                  : 'txt-right positive-balance'
                              }
                              fullWidth
                              placeholder=''
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name='quarter'
                              value={negativeValueConversion(finalTotal)}
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-sm-4'>
                      <div className='form-wrapper p-0 mt-2'>
                        <div className='mui-custom-form input-md field-xl'>
                          <div>
                            <TextField
                              label='Agency'
                              fullWidth
                              placeholder=''
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name='agency'
                              value={
                                createCms64Data.rebateProgramSelObj[0]
                                  ?.cms64AgencyName
                              }
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-sm-4'>
                      <div className='form-wrapper p-0 mt-2'>
                        <div className='mui-custom-form input-md field-xl'>
                          <div>
                            <TextField
                              label='Quarter Ended'
                              fullWidth
                              placeholder=''
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name='quarterended'
                              value={responseCMSRpt?.response?.data?.endDate}
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <>
                      <div className='col-sm-2 custom-text-center'>
                        <div className='form-wrapper p-0'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div
                              style={{
                                fontSize: '12px',
                                fontWeight: '600',
                                color: '#274463',
                              }}
                            >
                              <b>Quarter Ending Date</b>
                            </div>
                          </div>
                        </div>
                      </div>
                      {qtrDates.map((item) => {
                        return (
                          <div className='col-sm-2'>
                            <div className='form-wrapper p-0'>
                              <div className='mui-custom-form input-md field-xl'>
                                <div>
                                  <TextField
                                    fullWidth
                                    placeholder=''
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    name='date'
                                    value={item}
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      <div className='col-sm-2 mt-4 custom-box-middle'>
                        <div className='form-wrapper p-0 mt-2'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div />
                          </div>
                        </div>
                      </div>
                    </>
                    <>
                      <div className='col-sm-2 custom-text-center'>
                        <div className='form-wrapper p-0'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div
                              style={{
                                fontSize: '12px',
                                fontWeight: '600',
                                color: '#274463',
                              }}
                            >
                              <b>Calendar Quarter</b>
                            </div>
                          </div>
                        </div>
                      </div>
                      {calQuarters.map((item, key) => {
                        return (
                          <div className='col-sm-2' id={key}>
                            <div className='form-wrapper p-0'>
                              <div className='mui-custom-form input-md field-xl'>
                                <div>
                                  <TextField
                                    fullWidth
                                    placeholder=''
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    name='quarter'
                                    value={item}
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      <div className='col-sm-2 mt-4 custom-box-middle'>
                        <div className='form-wrapper p-0 mt-2'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div />
                          </div>
                        </div>
                      </div>
                    </>
                    <>
                      <div className='col-sm-2 custom-text-center'>
                        <div className='form-wrapper p-0'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div
                              style={{
                                fontSize: '12px',
                                fontWeight: '600',
                                color: '#274463',
                              }}
                            >
                              <b>Drug Rebate Quarter</b>
                            </div>
                          </div>
                        </div>
                      </div>
                      <>
                        {drugRebateQtrs.map((item, key) => {
                          return (
                            <div
                              className='col-sm-2 custom-box-middle'
                              id={key}
                            >
                              <div className='form-wrapper p-0'>
                                <div className='mui-custom-form input-md field-xl'>
                                  <div>
                                    <TextField
                                      fullWidth
                                      placeholder=''
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      name='quarter'
                                      value={item}
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                        <div className='col-sm-2 custom-text-center'>
                          <div className='form-wrapper p-0'>
                            <div className='mui-custom-form input-md field-xl'>
                              <div
                                style={{
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  color: '#274463',
                                }}
                              >
                                <b>Previous Quarters</b>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>

                      <div className='col-sm-2' style={{ display: 'none' }}>
                        <div className='form-wrapper p-0'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div
                              style={{
                                fontSize: '12px',
                                fontWeight: '600',
                                color: '#274463',
                              }}
                            >
                              <b>Quarters</b>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                    <>
                      <div className='col-sm-2 custom-text-center'>
                        <div className='form-wrapper p-0'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div
                              style={{
                                fontSize: '12px',
                                fontWeight: '600',
                                color: '#274463',
                              }}
                            >
                              <b>Adjustments From Unit Changes: </b>
                            </div>
                          </div>
                        </div>
                      </div>
                      {paymentsData.totalInvAdjs.map((item) => {
                        return (
                          <div className='col-sm-2 custom-box-middle'>
                            <div className='form-wrapper p-0'>
                              <div className='mui-custom-form input-md field-xl'>
                                <div>
                                  <TextField
                                    fullWidth
                                    className={
                                      item < 0
                                        ? 'txt-right negative-balance'
                                        : 'txt-right positive-balance'
                                    }
                                    placeholder=''
                                    InputLabelProps={{
                                      shrink: true,
                                      style: { color: '#274463' },
                                    }}
                                    InputProps={{ style: { color: 'red' } }}
                                    name='quarter'
                                    value={negativeValueConversion(item)}
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </>
                    <>
                      <div className='col-sm-2 custom-text-center'>
                        <div className='form-wrapper p-0'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div
                              style={{
                                fontSize: '12px',
                                fontWeight: '600',
                                color: '#274463',
                              }}
                            >
                              <b>
                                Unallocated Balances Allocated to this Quarter{' '}
                              </b>
                            </div>
                          </div>
                        </div>
                      </div>
                      {paymentsData.toQtr.map((item) => {
                        return (
                          <div className='col-sm-2 custom-box-middle'>
                            <div className='form-wrapper p-0 '>
                              <div className='mui-custom-form input-md field-xl'>
                                <div>
                                  <TextField
                                    fullWidth
                                    className={
                                      item < 0
                                        ? 'txt-right negative-balance'
                                        : 'txt-right positive-balance'
                                    }
                                    placeholder=''
                                    InputLabelProps={{
                                      shrink: true,
                                      style: { color: '#274463' },
                                    }}
                                    name='quarter'
                                    value={negativeValueConversion(item)}
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </>
                    <>
                      <div className='col-sm-2 custom-text-center'>
                        <div className='form-wrapper p-0'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div
                              style={{
                                fontSize: '12px',
                                fontWeight: '600',
                                color: '#274463',
                              }}
                            >
                              <b>
                                Unallocated Balances Allocated from this Quarter
                              </b>
                            </div>
                          </div>
                        </div>
                      </div>
                      {paymentsData.fromQtr.map((item) => {
                        return (
                          <div className='col-sm-2 custom-box-middle'>
                            <div className='form-wrapper p-0'>
                              <div className='mui-custom-form input-md field-xl'>
                                <div>
                                  <TextField
                                    fullWidth
                                    className={
                                      item < 0
                                        ? 'txt-right negative-balance'
                                        : 'txt-right positive-balance'
                                    }
                                    placeholder=''
                                    InputLabelProps={{
                                      shrink: true,
                                      style: { color: '#274463' },
                                    }}
                                    name='quarter'
                                    value={negativeValueConversion(item)}
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </>
                    <>
                      <div className='col-sm-2 custom-text-center'>
                        <div className='form-wrapper p-0'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div
                              style={{
                                fontSize: '12px',
                                fontWeight: '600',
                                color: '#274463',
                              }}
                            >
                              <b>
                                Total Adjustments to Previous Reported Quarter
                              </b>
                            </div>
                          </div>
                        </div>
                      </div>
                      {paymentsData.totalInvAdjs.map((item) => {
                        return (
                          <div className='col-sm-2 custom-box-middle'>
                            <div className='form-wrapper p-0'>
                              <div className='mui-custom-form input-md field-xl'>
                                <div>
                                  <TextField
                                    fullWidth
                                    className={
                                      item < 0
                                        ? 'txt-right negative-balance'
                                        : 'txt-right positive-balance'
                                    }
                                    placeholder=''
                                    InputLabelProps={{
                                      shrink: true,
                                      style: { color: '#274463' },
                                    }}
                                    name='quarter'
                                    value={negativeValueConversion(item)}
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </>
                  </div>
                  <div className='row' />
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(ResearchExistingCMS64Adjustments);
